export interface TUserMenu {
    menuList: TMenuItem[];
    resoureList: string[];
    role?: number;
    user?: TUser;
}

export interface TMenuItem {
    icon: string;
    id: string;
    menus: TMenuItem[];
    name: string;
    open: boolean;
    parent: boolean;
    parentId: string;
    resCode: string;
    sort: number;
    url: string;
    pv?: number;
    uv?: number;
}

export interface TUser {
    erp?: string;
    userName?: string;
    checksum?: number;
    created?: number;
    createdDate?: number;
    email?: string;
    expires?: number;
    expiresDate?: number;
    login?: boolean;
    mobile?: string;
    nick?: string;
    orgId?: string;
    orgName?: string;
    persistent?: boolean;
    pin?: string;
    userId?: number;
}

export interface TOrgListItem {
    cdcId: number;
    cdcName: string;
    relationBdcId: any;
}

export interface TJumpMenu {
    label: string;
    key: string;
    url: string;
}

export interface TFlowItem {
    id: number;
    icon: string;
    inSide: any;
    key: string;
    subMenu: TSubMenuItem[];
    title: string;
    url?: string;
}

export interface TSubMenuItem {
    icon: string;
    id: number;
    name: string;
    open: false;
    parent: false;
    parentId: string;
    resCode: string;
    sort: number;
    title: string;
    url: string;
    activeRule: string;
}

export interface TMenuJson {
    menuList: {
        flow: TFlowItem[];
        other: TFlowItem[];
        subApp: Array<{
            activeRule: string;
            entryDev: string;
            entryProd: string;
            name: string;
        }>;
    };
    user: TUser;
}

export interface TSubApp {
    activeRule: string;
    entryDev: string;
    entryProd: string;
    name: string;
}

export interface TQuickEntranceItem {
    key: string;
    label: string;
    url: string;
}

export interface TStoreData {
    layoutMode: string;
    user: TUser;
    flow: TFlowItem[];
    other: TFlowItem[];
    subMenuList: TSubMenuItem[];
    subApp: TSubApp[];
    subAppMap: { [key: string]: TSubApp };
    flowAndOtherActive: string;
    quickEntrance: TQuickEntranceItem[];
    customRecord: { [key: string]: TSubMenuItem[] };
    eventTracking: TTrackingData;
    userProcess: TUserProcess[];
    orgTree: TOrgTreeItem;
    orgActive: TOrgTreeItem;
    firstTenant: {
        tenantCode?: string;
        orgName?: string;
        orgCode?: string;
        appIcon?: string;
        appName?: string;
    };
}

export interface TMenuBuryDataItem {
    name?: string;
    PV?: number;
    weekPV?: number;
    monthPV?: number;
    UV?: number;
    weekUV?: number;
    monthUV?: number;
}

export interface TTrackingData {
    menuBuryData?: TMenuBuryDataItem[];
    totalMonthPV?: number;
    totalMonthUV?: number;
    totalPV?: number;
    totalUV?: number;
    totalWeekPV?: number;
    totalWeekUV?: number;
}

export interface TUserProcess {
    addsignRealName: null;
    assigneeStatus: null;
    beginTime: string;
    businessIntanceId: string;
    cancelStatus: string;
    continueStatus: string;
    currentPosition: number;
    currentStatus: string;
    currentTaskId: null;
    currentTaskKey: null;
    currentTaskName: null;
    followCode: null;
    handlerERP: null;
    isParallelNode: null;
    isParallelProcess: null;
    nextTaskName: null;
    nodeTips: null;
    pafProcessDefinitionId: string;
    parallelApprovelInfo: null;
    pcViewUrl: null;
    processDefinitionId: string;
    processDefinitionIsOuter: null;
    processDefinitionName: string;
    processId: null;
    processInstanceId: string;
    processInstanceName: string;
    reapplyStatus: string;
    siteOut: boolean;
    trackTasks: TTrackTasksItem[];
    url: string;
}

export interface TTrackTasksItem {
    assigneeERP: string;
    assigneeName: string;
    flowResult: null;
    handleInfo: string[];
    nodeTips: null;
    position: number;
    taskId: string;
    taskName: string;
    taskType: string;
}

export enum APP_PORTAL {
    CMS = 'jxc-portal-cms',
    CRM = 'jxc-portal-crm',
}

export interface TOrgTreeItem {
    class: string;
    orgCode: string;
    orgName: string;
    parentOrgCode: string;
    tenantCode: string;
    hasRelation?: boolean;
    children?: TOrgTreeItem[];
}
